import { useApi } from "../../../../../customer-experience/src/v2/src/utils";
import {
  RoadmapDto,
  RoadmapsClient,
} from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ROADMAPS_OVERVIEW } from "../utils/constants";
import { Dispatch, SetStateAction } from "react";
import { SnackbarState } from "../interfaces/SnackbarState";

export default function useCreateRoadmap(
  setSnackbars?: Dispatch<SetStateAction<SnackbarState[]>>
) {
  const api = useApi(RoadmapsClient);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roadmap: RoadmapDto) => {
      return await api.createRoadmap(roadmap);
    },
    onError: async () => {
      setSnackbars?.((prev: SnackbarState[]) => [
        ...prev, {
          key: new Date().getTime() + Math.random(),
          message: "There was an issue creating the item, please try again later.",
          severity: "error",
        }
      ]);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries([CACHE_KEY_ROADMAPS_OVERVIEW]);
    },
  });
}
